import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum CheckoutTreeTransformationErrorCode {
  SPLIT_NOT_FOUND = "SPLIT_NOT_FOUND",
  PROSPECTIVE_TREE_PARSE_ERROR = "PROSPECTIVE_TREE_PARSE_ERROR",
  SPLIT_NOT_FOUND_IN_PROSPECTIVE_TREE = "SPLIT_NOT_FOUND_IN_PROSPECTIVE_TREE",
  PROSPECTIVE_TREE_NOT_FOUND = "PROSPECTIVE_TREE_NOT_FOUND",
  CURRENT_TREE_HAS_SPLIT = "CURRENT_TREE_HAS_SPLIT",
  DELETED_CHECKOUT_EXPERIENCE = "DELETED_CHECKOUT_EXPERIENCE",
  CONTROL_TREATMENT_NOT_FOUND = "CONTROL_TREATMENT_NOT_FOUND",
}

export enum CheckoutTreeTransformationWarningCode {
  CHECKOUT_TREE_CONTINUITY_ERROR__CONTROL_IS_NOT_TRUE_CONTROL = "CHECKOUT_TREE_CONTINUITY_ERROR__CONTROL_IS_NOT_TRUE_CONTROL",
  CHECKOUT_TREE_CONTINUITY_ERROR__FOUND_CHANGE_OUTSIDE_SPLIT = "CHECKOUT_TREE_CONTINUITY_ERROR__FOUND_CHANGE_OUTSIDE_SPLIT",
  CURRENT_CHECKOUT_TREE_NOT_FOUND = "CURRENT_CHECKOUT_TREE_NOT_FOUND",
}

const ValidateCheckoutTreeTransformationWarning_ = z.object({
  code: createEnum(CheckoutTreeTransformationWarningCode),
  message: z.string(),
  subMessage: z.string().optional(),
});
export const ValidateCheckoutTreeTransformationWarning: z.ZodType<ValidateCheckoutTreeTransformationWarningType> =
  ValidateCheckoutTreeTransformationWarning_;
export interface ValidateCheckoutTreeTransformationWarningType extends z.infer<
  typeof ValidateCheckoutTreeTransformationWarning_
> {}

const ValidateCheckoutTreeTransformationError_ = z.object({
  code: createEnum(CheckoutTreeTransformationErrorCode),
  message: z.string(),
  subMessage: z.string().optional(),
});
export const ValidateCheckoutTreeTransformationError: z.ZodType<ValidateCheckoutTreeTransformationErrorType> =
  ValidateCheckoutTreeTransformationError_;
export interface ValidateCheckoutTreeTransformationErrorType extends z.infer<
  typeof ValidateCheckoutTreeTransformationError_
> {}
